import Fcm from '@/plugins/firebase/messaging'
import { isNotificationAllowed, requestPermission } from '@/plugins/push-notification/requestPermission'
import { toastBrowserNoSupport } from './toast'

const notificationOptions = {
  icon: '/img/icone-medio.png',
  vibrate: [200, 100, 200],
}

function handleFcmError(error) {
    if (error.code === 'messaging/token-update-failed') {
        console.warn(error)
        return
    }

    toastBrowserNoSupport()

    if (error.code === 'messaging/unsupported-browser' || error.code === 'browser-no-support') {
        console.warn(error)
        return
    }

    throw error
}

export async function init() {
    await requestPermission()

    if (isNotificationAllowed()) {
        await Fcm.start().catch(handleFcmError)
    }
}

export async function destroyTokens() {
    await requestPermission()

    if (isNotificationAllowed()) {
        await Fcm.destroyToken().catch(handleFcmError)
    }
}

export function showNotification(title, options = {}) {
    if (isNotificationAllowed()) {
      let n = new Notification(title, {
        ...notificationOptions,
        ...options
      })

      if (options.onclick) {
        n.onclick = options.onclick
      }

      if (options.link) {
        n.onclick = function() {
          window.open(options.link)
        }
      }

      return n
    }

    return null
}

export const actionsOnMessage =  {
    add(actions) {
        Fcm.addActions(actions)
    },

    set(actions) {
        Fcm.setActions(actions)
    }
}

export { forceToastNotification } from '@/plugins/push-notification/toast'
